"use strict";

var cutSequenceByRestrictionEnzyme = require("./cutSequenceByRestrictionEnzyme");

module.exports = function getCutsitesFromSequence(sequence, circular, restrictionEnzymes) {
  var cutsitesByName = {};
  for (var i = 0; i < restrictionEnzymes.length; i++) {
    var re = restrictionEnzymes[i];
    var cutsites = cutSequenceByRestrictionEnzyme(sequence, circular, re);
    if (cutsites.length) {
      cutsitesByName[re.name] = cutsites;
    }
  }
  return cutsitesByName;
};